module.exports = __webpack_public_path__ + "img/gw.7ffcfa41.svg";